import * as QC_FRConstants from '../../action/qc_fr/QC_FRConstants';
import _ from 'lodash';
import { IMAGE_STATUSES } from '../../../pages/finalReviewPage/FinalReviewPageConstants';
// import moment from 'moment';

const initialState = {
  reservedDomainsIds: [],
  domainDeliveredIdsData: [],
  domainDeliveredIdsDataIsFetching: false,
  domainDeliveredIdsDataErrorMessage: '',
  domainImagesStatusesIdsData: {},
  domainImagesStatusesIdsDataIsFetching: false,
  domainImagesStatusesIdsDataErrorMessage: '',
  filterSightingsIsFetching: false,
  filterSightingsData: {},
  filterSightingsErrorMessage: '',
  domainReserveData: [],
  domainReserveDataIsFetching: false,
  domainReserveDataErrorMessage: '',
  lastDomainSightingsData: {},
  lastDomainSightingsDataIsFetching: false,
  lastDomainSightingsDataErrorMessage: '',
  firstDomainSightingsData: {},
  firstDomainSightingsDataIsFetching: false,
  firstDomainSightingsDataErrorMessage: '',
  updateDomainAsReviewData: {},
  updateDomainAsReviewDataIsFetching: false,
  updateDomainAsReviewDataErrorMessage: '',
  domainForReviewData: {},
  domainForReviewDataIsFetching: false,
  domainForReviewDataErrorMessage: '',
  updateImageStatus: {},
  updateImageStatusIsFetching: false,
  updateImageStatusErrorMessage: '',
  setReturnedForCommentTrue: {},
  setReturnedForCommentTrueIsFetching: false,
  setReturnedForCommentTrueErrorMessage: '',
  updateImagesData: {},
  updateImagesDataIsFetching: false,
  updateImagesDataErrorMessage: '',
  setReturnedForReview: {},
  setReturnedForReviewIsFetching: false,
  setReturnedForReviewErrorMessage: '',
  domainReviewImagesData: {},
  updateDomainHoldDataIsFetching: false,
  updateDomainHoldDataErrorMessage: '',
  updateDomainReviewImagesData: {},
  deleteDomainHoldDataIsFetching: false,
  deleteDomainHoldDataErrorMessage: '',
  deleteDomainReviewImagesData: {},
  addToDeliveredData: [],
  downloadedImageData: {},
  downloadedImageHeaderData: '',
  downloadedImageDataIsFetching: false,
  downloadedImageDataErrorMessage: '',
  updateImagesHoldDataIsLoading: false,
  updateImagesHoldDataSuccess: false,
  updateImagesHoldDataError: false,
  updateImagesHoldData: null,
  sendUpdatedImgUrlIsLoading: false,
  sendUpdatedImgUrlData: {},
  sendUpdatedImgUrlErrorMessage: '',
  getSightingsInfoIsLoading: false,
  getSightingsInfoData: {},
  getSightingsInfoErrorMessage: ''
};

export const qc_frStore = (state = initialState, action) => {
  switch (action.type) {
    case QC_FRConstants.GET_DELIVERED_IDS_REQUEST:
      return {
        ...state,
        domainDeliveredIdsDataIsFetching: true,
        domainDeliveredIdsDataErrorMessage: ''
      };
    case QC_FRConstants.GET_DELIVERED_IDS_SUCCESS:
      return {
        ...state,
        domainDeliveredIdsDataIsFetching: false,
        domainDeliveredIdsData: action.data,
        domainDeliveredIdsDataErrorMessage: ''
      };
    case QC_FRConstants.GET_DELIVERED_IDS_FAILED:
      return {
        ...state,
        domainDeliveredIdsDataIsFetching: false,
        domainDeliveredIdsDataErrorMessage: action.error.message
      };
    case QC_FRConstants.GET_DELIVERED_IDS_CLEAR:
      return {
        ...state,
        domainDeliveredIdsDataIsFetching: false,
        domainDeliveredIdsData: [],
        domainDeliveredIdsDataErrorMessage: ''
      };

    case QC_FRConstants.GET_LAST_DOMAIN_SIGHTINGS_REQUEST:
      return {
        ...state,
        lastDomainSightingsDataIsFetching: true,
        lastDomainSightingsDataErrorMessage: ''
      };
    case QC_FRConstants.GET_LAST_DOMAIN_SIGHTINGS_SUCCESS:
      return {
        ...state,
        lastDomainSightingsDataIsFetching: false,
        lastDomainSightingsData: action.data,
        lastDomainSightingsDataErrorMessage: ''
      };
    case QC_FRConstants.GET_LAST_DOMAIN_SIGHTINGS_FAILED:
      return {
        ...state,
        lastDomainSightingsDataIsFetching: false,
        lastDomainSightingsDataErrorMessage: action.error.message
      };
    case QC_FRConstants.GET_LAST_DOMAIN_SIGHTINGS_CLEAR:
      return {
        ...state,
        lastDomainSightingsDataIsFetching: false,
        lastDomainSightingsData: {},
        lastDomainSightingsDataErrorMessage: ''
      };

    case QC_FRConstants.GET_FIRST_DOMAIN_SIGHTINGS_REQUEST:
      return {
        ...state,
        firstDomainSightingsDataIsFetching: true,
        firstDomainSightingsDataErrorMessage: ''
      };
    case QC_FRConstants.GET_FIRST_DOMAIN_SIGHTINGS_SUCCESS:
      return {
        ...state,
        firstDomainSightingsDataIsFetching: false,
        firstDomainSightingsData: action.data,
        firstDomainSightingsDataErrorMessage: ''
      };
    case QC_FRConstants.GET_FIRST_DOMAIN_SIGHTINGS_FAILED:
      return {
        ...state,
        firstDomainSightingsDataIsFetching: false,
        firstDomainSightingsDataErrorMessage: action.error.message
      };
    case QC_FRConstants.GET_FIRST_DOMAIN_SIGHTINGS_CLEAR:
      return {
        ...state,
        firstDomainSightingsDataIsFetching: false,
        firstDomainSightingsData: {},
        firstDomainSightingsDataErrorMessage: ''
      };

    case QC_FRConstants.GET_DOMAINS_IMAGES_STATUSES_IDS_REQUEST:
      return {
        ...state,
        domainImagesStatusesIdsDataIsFetching: true,
        domainImagesStatusesIdsDataErrorMessage: ''
      };
    case QC_FRConstants.GET_DOMAINS_IMAGES_STATUSES_IDS_SUCCESS:
      let deliveredData = _.cloneDeep(state.addToDeliveredData);
      // const sortByStatus = _.sortBy(action.data, 'status');

      const groupByStatus = _.groupBy(action.data, 'status');

      // let lastSortResult = [];
      let newIdentical = [];
      let finalSorting = [];

      // if (_.isEmpty(deliveredData)) {
      //   if (!_.isEmpty(action.data)) {
      //     deliveredData = _.map(action.data, (item) => {
      //       if (item.status === IMAGE_STATUSES.identical) {
      //         item.delivered = true;
      //       }

      //       return item;
      //     });
      //   }
      // }

      newIdentical = [
        ...(groupByStatus[IMAGE_STATUSES.identical]
          ? groupByStatus[IMAGE_STATUSES.identical]
          : []),
        ...(groupByStatus[IMAGE_STATUSES.pending]
          ? groupByStatus[IMAGE_STATUSES.pending]
          : []),
        ...(groupByStatus[IMAGE_STATUSES.offline]
          ? groupByStatus[IMAGE_STATUSES.offline]
          : []),
        ...(groupByStatus[IMAGE_STATUSES.duplicate]
          ? groupByStatus[IMAGE_STATUSES.duplicate]
          : []),
        ...(groupByStatus[IMAGE_STATUSES.legitimate]
          ? groupByStatus[IMAGE_STATUSES.legitimate]
          : []),
        ...(groupByStatus[IMAGE_STATUSES.notPursuable]
          ? groupByStatus[IMAGE_STATUSES.notPursuable]
          : []),
        ...(groupByStatus[IMAGE_STATUSES.nonIdentical]
          ? groupByStatus[IMAGE_STATUSES.nonIdentical]
          : [])
      ];

      const groupByDelivered = _.groupBy(newIdentical, 'delivered');

      finalSorting = [
        ...(groupByDelivered[false] ? groupByDelivered[false] : []),
        ...(groupByDelivered[true] ? groupByDelivered[true] : [])
      ];

      // _.forEach(sortByStatus, (item) => {
      //   if (
      //     moment(item.createdAt).isAfter(item.reviewedAt) &&
      //     item.status === IMAGE_STATUSES.identical
      //   ) {
      //     newIdentical.unshift(item);
      //   } else {
      //     lastSortResult.push(item);
      //   }
      // });

      // newIdentical = _.sortBy(newIdentical, [
      //   function (o) {
      //     return o.addedAfterDelivery;
      //   }
      // ]);

      // finalSorting = [...newIdentical.reverse(), ...lastSortResult];

      return {
        ...state,
        domainImagesStatusesIdsDataIsFetching: false,
        domainImagesStatusesIdsData: finalSorting,
        addToDeliveredData: deliveredData,
        domainImagesStatusesIdsDataErrorMessage: ''
      };
    case QC_FRConstants.GET_DOMAINS_IMAGES_STATUSES_IDS_FAILED:
      return {
        ...state,
        domainImagesStatusesIdsDataIsFetching: false,
        domainImagesStatusesIdsDataErrorMessage: action.error.message
      };
    case QC_FRConstants.GET_DOMAINS_IMAGES_STATUSES_IDS_CLEAR:
      return {
        ...state,
        domainImagesStatusesIdsDataIsFetching: false,
        domainImagesStatusesIdsData: {},
        domainImagesStatusesIdsDataErrorMessage: ''
      };

    case QC_FRConstants.FILTER_SIGHTINGS_REQUEST:
      return {
        ...state,
        filterSightingsIsFetching: true,
        filterSightingsErrorMessage: ''
      };
    case QC_FRConstants.FILTER_SIGHTINGS_SUCCESS:
      return {
        ...state,
        filterSightingsIsFetching: false,
        filterSightingsData: action.data,
        domainImagesStatusesIdsData: action.data.content,
        filterSightingsErrorMessage: ''
      };
    case QC_FRConstants.FILTER_SIGHTINGS_FAILED:
      return {
        ...state,
        filterSightingsIsFetching: false,
        filterSightingsErrorMessage: action.error.message
      };

    case QC_FRConstants.SAVE_DOMAIN_DATA_AS_REVIEW_REQUEST:
      return {
        ...state,
        updateDomainAsReviewDataIsFetching: true,
        updateDomainAsReviewDataErrorMessage: ''
      };
    case QC_FRConstants.SAVE_DOMAIN_DATA_AS_REVIEW_SUCCESS:
      return {
        ...state,
        updateDomainAsReviewDataIsFetching: false,
        updateDomainAsReviewData: action.data,
        updateDomainAsReviewDataErrorMessage: ''
      };
    case QC_FRConstants.SAVE_DOMAIN_DATA_AS_REVIEW_FAILED:
      return {
        ...state,
        updateDomainAsReviewDataIsFetching: false,
        updateDomainAsReviewDataErrorMessage: action.error.message
      };
    case QC_FRConstants.SAVE_DOMAIN_DATA_AS_REVIEW_CLEAR:
      return {
        ...state,
        updateDomainAsReviewDataIsFetching: false,
        updateDomainAsReviewData: {},
        updateDomainAsReviewDataErrorMessage: ''
      };
    case QC_FRConstants.UPDATE_IMAGE_STATUS_REQUEST:
      return {
        ...state,
        updateImageStatusIsFetching: true,
        updateImageStatusErrorMessage: ''
      };
    case QC_FRConstants.UPDATE_IMAGE_STATUS_SUCCESS:
      return {
        ...state,
        updateImageStatusIsFetching: false,
        updateImageStatus: action.data,
        updateImageStatusErrorMessage: ''
      };
    case QC_FRConstants.UPDATE_IMAGE_STATUS_FAILED:
      return {
        ...state,
        updateImageStatusErrorMessage: action.error.message,
        updateImageStatusIsFetching: false
      };
    case QC_FRConstants.UPDATE_IMAGE_STATUS_CLEAR:
      return {
        ...state,
        updateImageStatusIsFetching: false,
        updateImageStatus: {},
        updateImageStatusErrorMessage: ''
      };
    case QC_FRConstants.SET_RETURNED_FOR_COMMENT_TRUE_REQUEST:
      return {
        ...state,
        setReturnedForCommentTrueIsFetching: true,
        setReturnedForCommentTrueErrorMessage: ''
      };
    case QC_FRConstants.SET_RETURNED_FOR_COMMENT_TRUE_SUCCESS:
      return {
        ...state,
        setReturnedForCommentTrueIsFetching: false,
        setReturnedForCommentTrue: action.data,
        setReturnedForCommentTrueErrorMessage: ''
      };
    case QC_FRConstants.SET_RETURNED_FOR_COMMENT_TRUE_FAILED:
      return {
        ...state,
        setReturnedForCommentTrueErrorMessage: action.error.message,
        setReturnedForCommentTrueIsFetching: false
      };
    case QC_FRConstants.SET_RETURNED_FOR_COMMENT_TRUE_CLEAR:
      return {
        ...state,
        setReturnedForCommentTrueIsFetching: false,
        setReturnedForCommentTrue: {},
        setReturnedForCommentTrueErrorMessage: ''
      };

    case QC_FRConstants.SET_RETURNED_FOR_REVIEW_DATA_REQUEST:
      return {
        ...state,
        setReturnedForReviewIsFetching: true,
        setReturnedForReviewErrorMessage: ''
      };
    case QC_FRConstants.SET_RETURNED_FOR_REVIEW_DATA_SUCCESS:
      return {
        ...state,
        setReturnedForReviewIsFetching: false,
        setReturnedForReview: action.data,
        setReturnedForReviewErrorMessage: ''
      };
    case QC_FRConstants.SET_RETURNED_FOR_REVIEW_DATA_FAILED:
      return {
        ...state,
        setReturnedForReviewErrorMessage: action.error.message,
        setReturnedForReviewIsFetching: false
      };
    case QC_FRConstants.SET_RETURNED_FOR_REVIEW_DATA_CLEAR:
      return {
        ...state,
        setReturnedForReviewIsFetching: false,
        setReturnedForReview: {},
        setReturnedForReviewErrorMessage: ''
      };
    case QC_FRConstants.UPDATE_HOLD_DOMAIN_DATA_REQUEST:
      return {
        ...state,
        updateDomainHoldDataIsFetching: true,
        updateDomainHoldDataErrorMessage: ''
      };
    case QC_FRConstants.UPDATE_HOLD_DOMAIN_DATA_SUCCESS:
      return {
        ...state,
        updateDomainHoldDataIsFetching: false,
        updateDomainHoldData: action.data,
        domainHoldData: action.data,
        updateDomainHoldDataErrorMessage: ''
      };
    case QC_FRConstants.UPDATE_HOLD_DOMAIN_DATA_FAILED:
      return {
        ...state,
        updateDomainHoldDataErrorMessage: action.error.message,
        updateDomainHoldDataIsFetching: false
      };
    case QC_FRConstants.UPDATE_HOLD_DOMAIN_DATA_CLEAR:
      return {
        ...state,
        updateDomainHoldDataIsFetching: false,
        updateDomainHoldData: {},
        updateDomainHoldDataErrorMessage: ''
      };

    case QC_FRConstants.DELETE_HOLD_DOMAIN_DATA_REQUEST:
      return {
        ...state,
        deleteDomainHoldDataIsFetching: true,
        deleteDomainHoldDataErrorMessage: ''
      };
    case QC_FRConstants.DELETE_HOLD_DOMAIN_DATA_SUCCESS:
      return {
        ...state,
        deleteDomainHoldDataIsFetching: false,
        deleteDomainHoldData: action.data,
        domainHoldData: {},
        deleteDomainHoldDataErrorMessage: ''
      };
    case QC_FRConstants.DELETE_HOLD_DOMAIN_DATA_FAILED:
      return {
        ...state,
        deleteDomainHoldDataErrorMessage: action.error.message,
        deleteDomainHoldDataIsFetching: false
      };
    case QC_FRConstants.DELETE_HOLD_DOMAIN_DATA_CLEAR:
      return {
        ...state,
        deleteDomainHoldDataIsFetching: false,
        deleteDomainHoldData: {},
        deleteDomainHoldDataErrorMessage: ''
      };

    case QC_FRConstants.UPDATE_IMAGES_DATA_REQUEST:
      return {
        ...state,
        updateImagesDataIsFetching: true,
        updateImagesDataErrorMessage: ''
      };
    case QC_FRConstants.UPDATE_IMAGES_DATA_SUCCESS:
      return {
        ...state,
        updateImagesDataIsFetching: false,
        updateImagesData: action.data,
        updateImagesDataErrorMessage: ''
      };
    case QC_FRConstants.UPDATE_IMAGES_DATA_FAILED:
      return {
        ...state,
        updateImagesDataErrorMessage: action.error.message,
        updateImagesDataIsFetching: false
      };
    case QC_FRConstants.UPDATE_IMAGES_DATA_CLEAR:
      return {
        ...state,
        updateImagesDataIsFetching: false,
        updateImagesData: {},
        updateImagesDataErrorMessage: ''
      };

    case QC_FRConstants.CHANGE_DOMAIN_REVIEW_IMAGES_DATA:
      let newDomainReviewImagesData = _.cloneDeep(state.domainReviewImagesData);

      if (action.updateIndex) {
        newDomainReviewImagesData[action.updateIndex] = action.data;
      } else {
        newDomainReviewImagesData = _.merge(
          {},
          newDomainReviewImagesData,
          action.data
        );
      }

      return {
        ...state,
        domainReviewImagesData: newDomainReviewImagesData
      };

    case QC_FRConstants.CHANGE_DOMAIN_DATA:
      return {
        ...state
        // domainData: action.data,
      };

    case QC_FRConstants.CLEAR_DOMAIN_REVIEW_IMAGES_DATA:
      return {
        ...state,
        domainReviewImagesData: {}
      };

    case QC_FRConstants.ADD_TO_DELIVERED:
      let deliveredCloneData = _.cloneDeep(state.addToDeliveredData);
      let findIndex = _.findIndex(state.addToDeliveredData, {
        id: action.updateIndex
      });
      deliveredCloneData[findIndex].status = action.data.status;
      deliveredCloneData[findIndex].delivered = action.data.delivered;

      if (findIndex === -1) {
        deliveredCloneData.push(action.data);
      } else {
        deliveredCloneData[findIndex] = action.data;
      }

      return {
        ...state,
        addToDeliveredData: deliveredCloneData
      };
    case QC_FRConstants.CLEAR_ADD_TO_DELIVERED:
      return {
        ...state,
        addToDeliveredData: []
      };

    case QC_FRConstants.GET_RESERVE_DOMAIN_PENDING_REQUEST:
      return {
        ...state,
        domainReserveDataIsFetching: true,
        domainReserveDataErrorMessage: ''
      };
    case QC_FRConstants.GET_RESERVE_DOMAIN_PENDING_SUCCESS:
      return {
        ...state,
        domainReserveDataIsFetching: false,
        domainReserveData: action.data,
        domainReserveDataErrorMessage: ''
      };
    case QC_FRConstants.GET_RESERVE_DOMAIN_PENDING_FAILED:
      return {
        ...state,
        domainReserveDataIsFetching: false,
        domainReserveDataErrorMessage: action.error.message
      };
    case QC_FRConstants.GET_RESERVE_DOMAIN_PENDING_CLEAR:
      return {
        ...state,
        domainReserveDataIsFetching: false,
        domainReserveData: [],
        domainReserveDataErrorMessage: ''
      };

    case QC_FRConstants.GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING_REQUEST:
      return {
        ...state,
        domainForReviewDataIsFetching: true,
        domainForReviewDataErrorMessage: ''
      };
    case QC_FRConstants.GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING_SUCCESS:
      return {
        ...state,
        domainForReviewDataIsFetching: false,
        domainForReviewData: action.data,
        domainForReviewDataErrorMessage: ''
      };
    case QC_FRConstants.GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING_FAILED:
      return {
        ...state,
        domainForReviewDataIsFetching: false,
        domainForReviewDataErrorMessage: action.error.message
      };
    case QC_FRConstants.GET_RESERVE_DOMAIN_FOR_REVIEW_PENDING_CLEAR:
      return {
        ...state,
        domainForReviewDataIsFetching: false,
        domainForReviewData: [],
        domainForReviewDataErrorMessage: ''
      };
    case QC_FRConstants.GET_DOWNLOADED_IMAGE_DATA_REQUEST:
      return {
        ...state,
        downloadedImageDataIsFetching: true,
        downloadedImageDataErrorMessage: ''
      };
    case QC_FRConstants.GET_DOWNLOADED_IMAGE_DATA_SUCCESS:
      return {
        ...state,
        downloadedImageDataIsFetching: false,
        downloadedImageData: action.data,
        downloadedImageHeaderData: action.headers['content-type']
      };
    case QC_FRConstants.GET_DOWNLOADED_IMAGE_DATA_FAILED:
      return {
        ...state,
        downloadedImageDataIsFetching: false,
        downloadedImageData: [],
        downloadedImageDataErrorMessage: 'SERVER ERROR'
      };
    case QC_FRConstants.GET_DOWNLOADED_IMAGE_DATA_CLEAR:
      return {
        ...state,
        downloadedImageDataIsFetching: false,
        downloadedImageData: [],
        downloadedImageDataErrorMessage: ''
      };
    case QC_FRConstants.UPDATE_HOLD_IMAGE_DATA_REQUEST:
      return {
        ...state,
        updateImagesHoldDataIsLoading: true,
        updateImagesHoldDataError: false
      };
    case QC_FRConstants.UPDATE_HOLD_IMAGE_DATA_FAILED:
      return {
        ...state,
        updateImagesHoldDataIsLoading: false,
        updateImagesHoldDataError: true,
        updateImagesHoldDataSuccess: false
      };
    case QC_FRConstants.UPDATE_HOLD_IMAGE_DATA_SUCCESS:
      return {
        ...state,
        updateImagesHoldDataIsLoading: false,
        updateImagesHoldDataError: false,
        updateImagesHoldDataSuccess: true,
        updateImagesHoldData: action.data
      };

    case QC_FRConstants.SEND_UPDATED_IMAGE_URL_REQUEST:
      return {
        ...state,
        sendUpdatedImgUrlIsLoading: true,
        sendUpdatedImgUrlErrorMessage: ''
      };
    case QC_FRConstants.SEND_UPDATED_IMAGE_URL_SUCCESS:
      return {
        ...state,
        sendUpdatedImgUrlIsLoading: false,
        sendUpdatedImgUrlData: action.data
      };
    case QC_FRConstants.SEND_UPDATED_IMAGE_URL_FAILED:
      return {
        ...state,
        sendUpdatedImgUrlIsLoading: false,
        sendUpdatedImgUrlErrorMessage: 'SERVER ERROR'
      };

    case QC_FRConstants.GET_SIGHTINGS_INFO_REQUEST:
      return {
        ...state,
        getSightingsInfoIsLoading: true,
        getSightingsInfoErrorMessage: ''
      };
    case QC_FRConstants.GET_SIGHTINGS_INFO_SUCCESS:
      return {
        ...state,
        getSightingsInfoIsLoading: false,
        getSightingsInfoData: action.data
      };
    case QC_FRConstants.GET_SIGHTINGS_INFO_FAILED:
      return {
        ...state,
        getSightingsInfoIsLoading: false,
        getSightingsInfoErrorMessage: 'SERVER ERROR'
      };

    default:
      return state;
  }
};
